export default "__VITE_ASSET__DO61IisA__"